module.exports = __webpack_public_path__ + "media/images/icons/icon_google_login-bba033406b8fae1cae90a7a1b87d1eaf.svg";